import { render, staticRenderFns } from "./No04.vue?vue&type=template&id=7c56bf0e&scoped=true"
import script from "./No04.vue?vue&type=script&lang=js"
export * from "./No04.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c56bf0e",
  null
  
)

export default component.exports